export enum ApiResponseCodeEnum {
  Success = 0,
  Unknown = 1,
  NotFound = 2,
  AlreadyExists = 3,
  BadRequest = 4,
  NotOnline = 5,
  Timeout = 6,
  Busy = 7,
  Unsupported = 8,
  Unauthorized = 9,
  Forbidden = 16,
  ServerBusy = 10,
  InternalServerError = 11,
  NoVtdu = 12,
  NoNru = 13,
  WrongPassword = 14,
  DatabaseError = 15,
  MaximumRetriesReached = 17,
  ResourceLimit = 18,
}

export interface ApiBaseResponseDto<T> {
  code: ApiResponseCodeEnum;
  msg?: string;
  data?: T;
}
